"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketFixedBeet = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
/**
 * @category userTypes
 * @category generated
 */
exports.marketFixedBeet = new beet.BeetArgsStruct([
    ['discriminant', beet.u64],
    ['version', beet.u8],
    ['baseMintDecimals', beet.u8],
    ['quoteMintDecimals', beet.u8],
    ['baseVaultBump', beet.u8],
    ['quoteVaultBump', beet.u8],
    ['padding1', beet.uniformFixedSizeArray(beet.u8, 3)],
    ['baseMint', beetSolana.publicKey],
    ['quoteMint', beetSolana.publicKey],
    ['baseVault', beetSolana.publicKey],
    ['quoteVault', beetSolana.publicKey],
    ['orderSequenceNumber', beet.u64],
    ['numBytesAllocated', beet.u32],
    ['bidsRootIndex', beet.u32],
    ['bidsBestIndex', beet.u32],
    ['asksRootIndex', beet.u32],
    ['asksBestIndex', beet.u32],
    ['claimedSeatsRootIndex', beet.u32],
    ['freeListHeadIndex', beet.u32],
    ['padding2', beet.uniformFixedSizeArray(beet.u32, 1)],
    ['quoteVolume', beet.u64],
    ['padding3', beet.uniformFixedSizeArray(beet.u64, 8)],
], 'MarketFixed');
